export const _sharedActionsConstantsParagraphs = {
  CLEAR_BOOK_PARAS: "paras/FETCH_PARAGRAPHS_CLEAR",
  FETCH_PARAGRAPHS_SUCCESS: "paras/FETCH_PARAGRAPHS_SUCCESS",
  FETCH_CHAPTER_PARAS_SUCCESS: "paras/FETCH_CHAPTER_PARAS_SUCCESS",
  FETCH_CHAPTERS_PARAS_SUCCESS: "paras/FETCH_CHAPTERS_PARAS_SUCCESS",
};

export const _sharedActionsParagraphs = {
  fetchParaSuccess: (numberIdBook, parasObj) => ({
    type: _sharedActionsConstantsParagraphs.FETCH_PARAGRAPHS_SUCCESS,
    data: {nBookId: numberIdBook, parasObj}
  }),

  fetchChapterParasSuccess: (chapterId, paras, highlight) => ({
    type: _sharedActionsConstantsParagraphs.FETCH_CHAPTER_PARAS_SUCCESS,
    data: {chapterId, paras, highlight}
  }),
  // Same as {fetchChapterParasSuccess}, but for multiple chapters at once.
  fetchChaptersParasSuccess: (numberIdBook, mapChapterNumberToParas) => ({
    type: _sharedActionsConstantsParagraphs.FETCH_CHAPTERS_PARAS_SUCCESS,
    data: {bookIdOrigin: numberIdBook, mapChapterNumberToParas}
  }),

  clearBookParas: (nBookId) => ({
    type: _sharedActionsConstantsParagraphs.CLEAR_BOOK_PARAS,
    data: nBookId,
  }),
};
